<template>
  <div class="jdRecommend">
    <a id="auto-re" @click="recommend" :href="'line://msg/text/?'+this.ShareDescription+'%0D%0Aline://app/1638626894-xmdRy8y8?c='+this.channelId+'&rec='+this.userId"></a>
    <img src="../assets/JD.jpg">
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mapGetters } from 'vuex'

export default {
  name: 'jdRecommend',
  methods: {
    recommend: function() {
      this.$store.dispatch('recommend', 
      {
        c: this.channelId
      })
    }
  },
  computed: {
    ...mapGetters({
      userId: 'userId',
      channelId: 'channelId',
      ShareDescription:'ShareDescription'
    })
  },
  mounted() {
    // 導至邀請好友 //
    setTimeout(function () {
      console.log(this.userId)
      document.getElementById('auto-re').click();
    }, 2000);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
}
img {
  width: 70%;
  border-radius: 20%;
  margin-top: 10%;
}
</style>


// WEBPACK FOOTER //
// src/components/jdRecommend.vue